import Cookies from "js-cookie";
import { STORAGE } from "project-config/constants/storage";

export function getUserKey() {
  // note: STORAGE.RAYVISION_USERKEY === STORAGE.USER_KEY
  return Cookies.get(STORAGE.RAYVISION_USERKEY);
}

export function getUserId() {
  return localStorage.getItem(STORAGE.USER_ID) || "";
}

export function getPreUserId() {
  return localStorage.getItem(STORAGE.PRE_USER_ID) || "";
}
